// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#slottedfield[data-v-892225fa]{margin-top:20px}#slottedfield .link[data-v-892225fa]{cursor:pointer}.alignleft[data-v-892225fa]{float:left}.alignright[data-v-892225fa]{float:right}@media (max-width:665px){.alignright[data-v-892225fa]{float:none}}", ""]);
// Exports
module.exports = exports;
